import z from 'zod'

import { iconNames } from '@/modules/tiktok-research/videos/ui/create-list-form/icon-picker/consts.ts'

export const listCreationFormSchema = z.object({
  name: z.string().nonempty(),
  icon: z.enum(iconNames),
  iconColor: z.string().nonempty(),
})

export type CreateListFormValues = z.infer<typeof listCreationFormSchema>

export const defaultList: CreateListFormValues = {
  icon: 'emojiEmotions',
  iconColor: '#1708FF',
  name: '',
}
